import { render, staticRenderFns } from "./record.vue?vue&type=template&id=3d4a8c66&scoped=true&"
import script from "./record.vue?vue&type=script&lang=ts&"
export * from "./record.vue?vue&type=script&lang=ts&"
import style0 from "./record.vue?vue&type=style&index=0&id=3d4a8c66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4a8c66",
  null
  
)

export default component.exports